module.exports = __webpack_public_path__ + "img/pitria_yes.882117c2.png";